var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#9197B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 6.27273H16.55V5H15.25V6.27273H8.75V5H7.45V6.27273H6.8C6.085 6.27273 5.5 6.84545 5.5 7.54545V17.7273C5.5 18.4273 6.085 19 6.8 19H17.2C17.915 19 18.5 18.4273 18.5 17.7273V7.54545C18.5 6.84545 17.915 6.27273 17.2 6.27273ZM17.2 17.7273H6.8V10.7273H17.2V17.7273ZM17.2 9.45455H6.8V7.54545H17.2V9.45455Z",
    fill: "#9197B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.ae097930f4825073e5cd6f6f0d7955f2.svg";
export { ForwardRef as ReactComponent };